"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatchHeightProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MatchHeightProvider = exports.MatchHeightProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(MatchHeightProvider, _React$Component);
  var _super = _createSuper(MatchHeightProvider);
  function MatchHeightProvider() {
    var _this;
    _classCallCheck(this, MatchHeightProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleResize", (0, _lodash["default"])(function () {
      _this.resetHeightsAndSubscribers();
    }, 100));
    _defineProperty(_assertThisInitialized(_this), "resetHeightsAndSubscribers", function () {
      _this.heights = {};
      _this.subscribers = [];
    });
    _defineProperty(_assertThisInitialized(_this), "heights", {});
    _defineProperty(_assertThisInitialized(_this), "nextFrame", null);
    _defineProperty(_assertThisInitialized(_this), "subscribers", []);
    _defineProperty(_assertThisInitialized(_this), "reportHeight", function (name, height) {
      var lastHeight = _this.heights[name] || 0;
      _this.heights[name] = Math.max(height, lastHeight);
      _this.subscribers.filter(function (_ref) {
        var subName = _ref.name;
        return subName === name;
      }).forEach(function (_ref2) {
        var callback = _ref2.callback;
        return callback(_this.heights[name]);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "subscribe", function (handlerPair) {
      _this.subscribers.push(handlerPair);
      var unsubscribe = function unsubscribe() {
        var index = _this.subscribers.findIndex(function (x) {
          return x === handlerPair;
        });
        _this.subscribers = [].concat(_toConsumableArray(_this.subscribers.slice(0, index)), _toConsumableArray(_this.subscribers.slice(index + 1)));
      };
      return unsubscribe;
    });
    return _this;
  }
  _createClass(MatchHeightProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var subscribe = this.subscribe,
        reportHeight = this.reportHeight;
      return {
        matchHeight: {
          subscribe: subscribe,
          reportHeight: reportHeight
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.handleScreenSizeChange) {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('orientationchange', this.handleReize);
    }
    /* istanbul ignore next */

    /* istanbul ignore next */
  }, {
    key: "render",
    value: function render() {
      var style = _objectSpread({}, this.props.style);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, 'matchHeightProvider'),
        style: style,
        "data-qe-id": this.props.qeId
      }, this.props.children);
    }
  }]);
  return MatchHeightProvider;
}(_react["default"].Component);
_defineProperty(MatchHeightProvider, "childContextTypes", {
  matchHeight: _propTypes["default"].shape({
    subscribe: _propTypes["default"].func,
    reportHeight: _propTypes["default"].func
  })
});
_defineProperty(MatchHeightProvider, "propTypes", {
  className: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  handleScreenSizeChange: _propTypes["default"].bool,
  qeId: _propTypes["default"].string
});
_defineProperty(MatchHeightProvider, "defaultProps", {
  className: '',
  style: {},
  handleScreenSizeChange: false,
  qeId: undefined
});